import { Link } from "react-router-dom";
import Container from "./Container";

interface Crumb {
  label: string;
  to?: string;
}

interface PageHeroProps {
  title: string;
  subtitle?: string;
  crumbs?: Crumb[];
  image: string;
}

export default function PageHero({ title, subtitle, crumbs = [], image }: PageHeroProps) {
  return (
    <section className="relative overflow-hidden bg-primary-950">
      <img
        src={image}
        alt=""
        aria-hidden="true"
        className="absolute inset-0 h-full w-full object-cover object-top opacity-40"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-primary-950/95 via-primary-950/80 to-primary-900/60"></div>

      <Container className="relative pb-12 pt-28 md:pb-16 md:pt-36">
        {crumbs.length > 0 && (
          <nav aria-label="Ruta de navegación" className="mb-4">
            <ol className="flex flex-wrap items-center gap-2 text-xs font-label text-primary-200">
              {crumbs.map((crumb, index) => (
                <li key={`${crumb.label}-${index}`} className="flex items-center gap-2">
                  {crumb.to ? (
                    <Link to={crumb.to} className="transition-colors hover:text-accent-300">
                      {crumb.label}
                    </Link>
                  ) : (
                    <span className="text-primary-100">{crumb.label}</span>
                  )}
                  {index < crumbs.length - 1 && (
                    <i className="ri-arrow-right-s-line text-sm leading-none" aria-hidden="true"></i>
                  )}
                </li>
              ))}
            </ol>
          </nav>
        )}

        <h1 className="max-w-3xl text-3xl font-heading font-bold text-balance text-primary-50 md:text-5xl">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-4 max-w-2xl text-sm leading-relaxed text-primary-100 md:text-base">
            {subtitle}
          </p>
        )}
      </Container>
    </section>
  );
}